/* Nude Project Theme — Marquee JS (pause on hover) */
(function() {
  'use strict';
  // Pause-on-hover is handled purely via CSS :hover pseudo-class
  // This file is kept for potential future enhancements
})();
